import React, { useContext, useState } from 'react';
import './Options/Filter.css';
import filterContext from '../context/filters/filterContext';
import { Checkbox } from 'antd';

function FilterContent() {
	const { clientId } = window.config;
	const {
		nameOfFilter,
		standardfilter,
		branchfilter,
		boardsfilter,
		batchfilter,
		subjectfilter,
		level,
		schoolFilter,
		setstandardfilter,
		setbranchfilter,
		setboardsfilter,
		setbatchfilter,
		setsubjectfilter,
		setlevel,
		setSchoolFilter,
		programFilter,
		setProgramFilter,
	} = useContext(filterContext);

	const handleCheckboxChange = event => {
		const { name, checked } = event.target;
		console.log('standardfilter', standardfilter);
		if (!nameOfFilter) {
			return;
		}

		if (nameOfFilter.filterName === 'Standard') {
			if (clientId == '65d87f80e92e6e1e90072d2d') {
				setbranchfilter(prevBranchFilter => ({
					...prevBranchFilter,
					[name]: checked,
				}));
			} else {
				setstandardfilter(prevStandardFilter => ({
					...prevStandardFilter,
					[name]: checked,
				}));
			}
		} else if (
			nameOfFilter.filterName === 'Batch' ||
			nameOfFilter.filterName === 'Sub Sections'
		) {
			setbatchfilter(prevBatchFilter => ({
				...prevBatchFilter,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'Board') {
			setboardsfilter(prevBoardsFilter => ({
				...prevBoardsFilter,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'Branch') {
			setbranchfilter(prevBranchFilter => ({
				...prevBranchFilter,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'Subject') {
			setsubjectfilter(prevSubjectFilter => ({
				...prevSubjectFilter,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'Level') {
			setlevel(prevLevel => ({
				...prevLevel,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'School') {
			setSchoolFilter(prevSchoolFilter => ({
				...prevSchoolFilter,
				[name]: checked,
			}));
		} else if (nameOfFilter.filterName === 'Program') {
			setProgramFilter(prevSchoolFilter => ({
				...prevSchoolFilter,
				[name]: checked,
			}));
		}
	};
	const handleCheckboxChecked = item => {
		if (!nameOfFilter) {
			return false;
		}

		if (nameOfFilter.filterName === 'Standard') {
			if (clientId == '65d87f80e92e6e1e90072d2d') {
				return branchfilter && branchfilter[`${item}`];
			} else {
				return standardfilter && standardfilter[`${item}`];
			}
		} else if (
			nameOfFilter.filterName === 'Batch' ||
			nameOfFilter.filterName === 'Sub Sections'
		) {
			return batchfilter && batchfilter[`${item}`];
		} else if (nameOfFilter.filterName === 'Board') {
			return boardsfilter && boardsfilter[`${item}`];
		} else if (nameOfFilter.filterName === 'Branch') {
			return branchfilter && branchfilter[`${item}`];
		} else if (nameOfFilter.filterName === 'Subject') {
			return subjectfilter && subjectfilter[`${item}`];
		} else if (nameOfFilter.filterName === 'Level') {
			return level && level[`${item}`];
		} else if (nameOfFilter.filterName === 'School') {
			return schoolFilter && schoolFilter[`${item}`];
		} else if (nameOfFilter.filterName === 'Program') {
			return programFilter && programFilter[`${item}`];
		}

		return false;
	};

	return (
		<>
			<div>
				{nameOfFilter &&
					nameOfFilter.options.map((item, index) => (
						<div
							className="filterStyle"
							style={{ height: '60px', marginRight: '0px' }}
							key={index}
						>
							<label htmlFor={`input-field${index + 1}`} className="labelStyle">
								{item}
							</label>

							<Checkbox
								id={`input-field${index + 1}`}
								className="rounded-checkbox"
								type="checkbox"
								name={item}
								onChange={handleCheckboxChange}
								checked={handleCheckboxChecked(item)}
							/>
						</div>
					))}
			</div>
		</>
	);
}

export default FilterContent;
